<template>
    <div>
        <el-upload drag :on-change="handlechange" :file-list="filelist" :auto-upload="false" :multiple="false" action>
            <i class="el-icon-upload"></i>
            <div style="color: red" slot="tip">
                <p>数据从excel的"Sheet1"工作表导入</p>
                <p>"Sheet1"工作表不能有合并单元格</p>
                <p>excel表格后缀名需为xlsx</p>
                <p>数据读取从第二行开始</p>
            </div>
        </el-upload>
        <!-- <el-button type="primary" style="width: 50%" v-if="filelist.length > 0" @click="submit">上传</el-button> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            filelist: []
        }
    },
    methods: {
        handlechange(file, filelist) {
            let dotpos = file.name.indexOf(".");
            let filetype = file.name.slice(dotpos + 1, file.name.length);
            if (filetype != "xlsx") {
                this.$message("文件格式必须为xlsx");
                return false;
            }
            //   this.collectionlabel = file.name.substring(0, dotpos);
            this.filelist = filelist.slice(-1); //只允许上传一个
            this.$emit("exceldone",file.raw)
            // this.file = file.raw;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/exceltodb/defineddb_excel.vue